import gql from 'graphql-tag';

import type { BlogDraft } from 'src/data/blog';
import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationCreateFormatCompliantBlogPostDraftArgs } from 'src/types/backend';

import { FRAGMENT_BLOG_POST_BUILDER_DRAFT } from './schema';

const MUTATION = gql`
  mutation CreateFormatCompliantBlogPostDraft($id: ID!) {
    createFormatCompliantBlogPostDraft(id: $id) {
      ...BlogPostBuilderDraft
    }
  }
  ${FRAGMENT_BLOG_POST_BUILDER_DRAFT}
`;

type Variables = BackendMutationCreateFormatCompliantBlogPostDraftArgs;

export const createFormatCompliantBlogPostDraft = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<BlogDraft>(result.data);
};
